<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 d-inline-block mb-0">
            {{ $t("menu.package") }}
          </h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-breadcrumb />
          </nav>
        </div>
        <div class="col-lg-6 col-5 text-right">
          <base-button
            size="md"
            type="neutral"
            class="btn-primary"
            @click="handleCreate()"
            >{{ $t("save") }}</base-button
          >
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--6">
      <div class="card mb-4">
        <!-- Card header -->
        <div class="card-header">
          <h3 class="mb-0">{{ $t("package.create") }}</h3>
        </div>
        <!-- Card body -->
        <div class="card-body">
          <!-- Form groups used in grid -->

          <form>
            <div class="form-group row">
              <label for="package-name" class="col-md-2 col-form-label form-control-label">{{
                $t("package.name")
              }} *</label>
              <div class="col-md-10">
                <base-input id="package-name" v-model="name"></base-input>
              </div>
            </div>

            <div class="form-group row">
              <label for="package-code" class="col-md-2 col-form-label form-control-label">{{
                $t("package.code")
              }} *</label>
              <div class="col-md-10">
                <base-input id="package-code" v-model="code"></base-input>
              </div>
            </div>

            <div class="form-group row">
              <label for="package-profile" class="col-md-2 col-form-label form-control-label">{{
                $t("package.profile")
              }} *</label>
              <div class="col-md-10">
                <base-input id="package-profile" v-model="profile"></base-input>
              </div>
            </div>

            <div class="form-group row">
              <label for="package-cos" class="col-md-2 col-form-label form-control-label">{{
                $t("package.cos")
              }} *</label>
              <div class="col-md-10">
                <base-input id="package-cos" v-model="cosid"></base-input>
              </div>
            </div>


          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FileInput from "@/components/Inputs/FileInput";
import { mapActions } from "vuex";
import swal from "sweetalert2";
export default {
  name: "form-elements",
  components: {
    FileInput
  },
  data() {
    return {
      name: "",
      code: "",
      profile: "",
      cosid: ""
    };
  },
  methods: {
    ...mapActions({
      createData: "Package/createData",
      updateData: "Package/updateData",
      deleteData: "Package/deleteData",
      listData: "Package/listData"
    }),
    filesChange(files) {
      this.inputs.file = files;
    },
    handleCreate() {
      this.createData({
        name: this.name,
        code: this.code,
        persistentProfile: this.profile,
        classOfService: this.cosid,
        featureJson: ""
      })
        .then(resp => {
          console.log(resp);
          swal
            .fire({
              title: this.$t("package.create_success"),
              icon: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              buttonsStyling: false
            })
            .then(result => {
              this.$router.push({ name: "package" });
            });
        })
        .catch(err => {
          swal.fire({
            title: this.$t(err.response.data.Msg),
            text: this.getErrorText(err.response.data),
            icon: "error",
            confirmButtonClass: "btn btn-danger btn-fill",
            buttonsStyling: false
          });
        });
    }
  }
};
</script>

<style scoped>
.form-group {
  margin-bottom: 0.2rem !important;
}
</style>
